import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/personnel/details/index.js